<div class="topbar">
  <div class="topbar-wrapper">
    @if (excludeLink) {
      <div class="logo">
        <img src="/assets/img/triggerbee-logo-black.svg" />
      </div>
    } @else {
      <a class="logo" [routerLink]="['/']">
        <img src="/assets/img/triggerbee-logo-black.svg" />
      </a>
    }
  </div>
</div>
